import 'twin.macro';

import imgLogo from '../assets/svgs/logo.svg';
import { social } from './Header';

const Footer = () => {
  return (
    <footer tw="w-full h-[431px] md:h-[217px] bg-footer-mobile md:bg-footer-desktop bg-no-repeat bg-bottom bg-cover">
      <div tw="px-[8.33vw] pt-[83px] md:pt-0 w-full flex flex-col md:flex-row md:justify-between items-center md:items-start gap-8">
        <div tw="text-center md:text-left">
          <a href="https://joystickgaming.io">
            <img alt="logo" src={imgLogo} tw="w-full max-w-[162px]" />
          </a>
          <div tw="pt-[22px] text-sm tracking-normal text-[#857E9A]">
            © 2022 Joystick
          </div>
        </div>
        <div tw="flex flex-col items-center md:items-end">
          <ul tw="flex gap-4">
            {social.map((item) => (
              <li key={item.title}>
                <a href={item.url} rel="noreferrer" target="_blank">
                  <img
                    alt={item.title}
                    src={item.icon}
                    title={item.title}
                    width={item.width}
                  />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
